import { useEffect } from "react";
import type { ReactNode } from "react";

/**
 * Os dois territórios do Genesis Lux (ADR-008).
 *
 *   admin   escuro — área da Lara. Espelha o site institucional dela.
 *   client  creme  — área da cliente. Espelha os carrosséis do Instagram dela.
 *
 * A classe vai no <html> porque `backdrop-filter` do Liquid Glass precisa
 * enxergar o fundo da página, e porque a cor da barra de status do iOS é lida
 * da tag <meta name="theme-color">, atualizada aqui junto.
 */

export type Territory = "admin" | "client";

const THEME_COLOR: Record<Territory, string> = {
  admin: "#140808",
  client: "#E5DED2",
};

export function Theme({
  territory,
  children,
}: {
  territory: Territory;
  children: ReactNode;
}) {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove("theme-admin", "theme-client");
    root.classList.add(`theme-${territory}`);

    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute("content", THEME_COLOR[territory]);
  }, [territory]);

  return <>{children}</>;
}
